import { InternalAxiosRequestConfig } from 'axios';
import { Role } from '../../types';
import { APP_ROLE_PARAM_KEY, rolesMapping } from '../const';
import { getRoleAppUrl } from './getRoleAppUrl';

class RolesManipulator {
  static CURRENT_ROLE_STORAGE_KEY = 'vestra_current_user_role';

  private isKnownRole(role: string | null): role is Role {
    return Boolean(role && Object.values(Role).includes(role as Role));
  }

  private isValidRole(role: string | null): role is Role {
    if (!this.isKnownRole(role)) return false;

    const roleAppUrl = new URL(rolesMapping[role].app.url, window.location.origin);
    const currentUrl = new URL(window.location.href);

    if (roleAppUrl.hostname === 'localhost' && currentUrl.hostname === 'localhost') {
      return roleAppUrl.port === currentUrl.port;
    }

    return roleAppUrl.origin === currentUrl.origin;
  }

  private redirectToRoleApp(role: Role): void {
    window.location.replace(getRoleAppUrl(role));
  }

  sync_params_and_storage_roles(roles: Role[]): void {
    const paramsRole = new URLSearchParams(window.location.search).get(APP_ROLE_PARAM_KEY);

    if (!this.isKnownRole(paramsRole)) return;

    if (!this.isValidRole(paramsRole)) {
      this.redirectToRoleApp(paramsRole);
      return;
    }

    const userHasRole = roles.includes(paramsRole);

    if (userHasRole) {
      this.set_current_user_role(paramsRole);
    }

    // setParams(params => {
    //   params.delete(APP_ROLE_PARAM_KEY);
    //   return params;
    // });
  }

  get current_user_role(): null | Role {
    const searchParams = new URLSearchParams(window.location.search);

    const paramsRole = searchParams.get(APP_ROLE_PARAM_KEY);
    const localStorageRole = localStorage.getItem(RolesManipulator.CURRENT_ROLE_STORAGE_KEY);

    if (this.isKnownRole(paramsRole)) {
      return this.isValidRole(paramsRole) ? paramsRole : null;
    }

    const resolveLocalStorageRole =
      localStorageRole && this.isValidRole(localStorageRole) ? localStorageRole : null;

    return resolveLocalStorageRole as Role;
  }

  set_current_user_role(role: string) {
    localStorage.setItem(RolesManipulator.CURRENT_ROLE_STORAGE_KEY, role);
  }

  apply_app_role_header(config: InternalAxiosRequestConfig) {
    if (this.current_user_role && Object.values(Role).includes(this.current_user_role as Role)) {
      config.headers.set(`x-${APP_ROLE_PARAM_KEY}`, this.current_user_role);
    }
    return config;
  }
}

export const rolesManipulator = new RolesManipulator();
